
/**
 * 
 * @hidden
 */
export enum ParameterDirection {

    /**
     * 
     */
    Input = 0,

    /**
     * 
     */
    Output = 1,
}
